import { Link } from 'react-router-dom';
import { ChevronRight, MessageCircle, Pill } from 'lucide-react';
import { dtpPath, useDtpParams } from '../../lib/clinicSite';
import { usePatientUnreadMessages } from '../../hooks/usePatientUnreadMessages';

/**
 * Home card for the care team: unread replies, and the way in to Messages and
 * My treatments. Self-contained (it loads its own unread count) so the home
 * page can drop it in without new data plumbing.
 */
export function CareTeamHomeCard() {
  const { physicianId } = useDtpParams();
  const unread = usePatientUnreadMessages();
  return (
    <section aria-labelledby="care-team" className="portal-card p-6 sm:p-7">
      <div className="flex items-center gap-3">
        <span className="grid h-9 w-9 place-items-center rounded-xl bg-[var(--portal-tint-1)]"><MessageCircle aria-hidden="true" className="h-[18px] w-[18px]" /></span>
        <h2 id="care-team" className="portal-display text-lg font-semibold">Care team</h2>
      </div>
      <p className="mt-4 text-[15px]">
        {unread > 0
          ? <span className="font-semibold">{unread === 1 ? '1 new message' : `${unread} new messages`} from your care team.</span>
          : <span className="text-[var(--portal-muted)]">Questions about your treatment or a refill? Message your care team.</span>}
      </p>
      <div className="mt-4 flex flex-wrap gap-2">
        <Link to={dtpPath(physicianId, '/messages')}
          className="inline-flex h-10 items-center gap-2 rounded-full bg-[var(--portal-primary)] px-4 text-sm font-semibold text-[var(--portal-primary-fg)] hover:opacity-90">
          {unread > 0 ? 'Read messages' : 'Messages'}<ChevronRight aria-hidden="true" className="h-4 w-4" />
        </Link>
        <Link to={dtpPath(physicianId, '/treatments')}
          className="inline-flex h-10 items-center gap-2 rounded-full bg-white/80 px-4 text-sm font-semibold ring-1 ring-[var(--portal-line)] hover:bg-white">
          <Pill aria-hidden="true" className="h-4 w-4" />My treatments
        </Link>
      </div>
    </section>
  );
}
